import React from 'react';
import Fade from 'react-reveal/Fade';
import Grid from '@mui/material/Grid';

import { PrizesWrapper } from './prizes.styled';
import Container from '../container/container.component';
import SubmitButton from '../submitButton/submitButton.component';
import { colors } from '&assets/constants/colors';
import { useNavigate } from 'react-router-dom';

interface Props {
	className?: string;
	prizes?: any;
}

const PrizesComponent = (props: Props) => {
	const { className, prizes } = props;
	const navigate = useNavigate();

	return (
		<PrizesWrapper className={className ? className : ''}>
			<Container>
				<Fade top cascade>
					<div className="content">
						<div className="shading-first"></div>
						<div className="shading-second"></div>
						<p className="title">Prizes</p>
						<div className="cards">
							{prizes?.length > 0 &&
								prizes.map((prize: any, index: number) => {
									return (
										<div className="card" key={index}>
											<span className="description">{prize.description}</span>

											<span className="subtitle">{prize.title}</span>
										</div>
									);
								})}
						</div>
						{/* <SubmitButton
							title="APPLY NOW"
							className="apply-now"
							id="apply-now-btn"
							icon={true}
							iconColor={colors.white}
							handleClick={() => navigate('/submit-challenge')}
						/> */}
					</div>
				</Fade>
			</Container>
		</PrizesWrapper>
	);
};

export default PrizesComponent;
